import { HEADER_CONFIG } from "@/shared/config/header.config";
import { getThemeClass, getThemeComponentClasses } from "@/shared/lib/themeComponentClasses";
import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { LayoutDashboard } from "lucide-react";
import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { App_Url_New } from "../common/static";
import { SiteNavItem } from "./SiteNavItem";

function DashboardNavButton() {
  const tableClasses = getThemeComponentClasses().table;
  const navigate = useNavigate();
  const location = useLocation();
  const {
    auth: { customerAuth },
  } = usePosterReducers();

  const accessToken = customerAuth?.access_token || null;
  const dashboardUrl = App_Url_New.D2CPageUrl.retailDashboard;
  const isDashboardPage = location.pathname === dashboardUrl;

  if (!accessToken || isDashboardPage) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(dashboardUrl)}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1.5 text-sm font-semibold transition-all duration-200 ${getThemeClass(tableClasses.controlBorderColor, "border-theme-border-strong/70")} ${getThemeClass(tableClasses.controlBgColor, "bg-theme-text")} ${getThemeClass(tableClasses.controlTextColor, "text-theme-text-inverse")} hover:bg-theme-text/80`}
    >
      <LayoutDashboard className="h-4 w-4 shrink-0" />
      <span>Dashboard</span>
    </button>
  );
}

export function SiteDesktopNav() {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const closeTimerRef = useRef<number | null>(null);

  const cancelClose = () => {
    if (closeTimerRef.current) {
      window.clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimerRef.current = window.setTimeout(() => {
      setActiveMenu(null);
    }, 140);
  };

  return (
    <nav className="hidden items-center gap-6 lg:flex">
      <DashboardNavButton />

      {HEADER_CONFIG.navigation.map((item) => (
        <SiteNavItem
          key={item.label}
          item={item}
          activeMenu={activeMenu}
          onOpen={setActiveMenu}
          onClose={() => setActiveMenu(null)}
          onScheduleClose={scheduleClose}
          onCancelClose={cancelClose}
        />
      ))}
    </nav>
  );
}
